import React, { useEffect } from 'react';
import { func } from 'prop-types';
import { compose } from 'redux';
import { connect, useDispatch, useSelector } from 'react-redux';
import { injectIntl } from 'react-intl';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

import css from './TermsAndConditionsCustomPage.module.css';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import { LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { isScrollingDisabled } from '../../ducks/ui.duck';

import { createResourceLocatorString } from '../../util/routes';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { useHistory } from 'react-router-dom';
import { fetchTerms, getTermsSelector } from '../../ducks/strapi.duck';
import { convertStrapiRichTextToReact, extractPlainTextFromStrapiRichText } from '../../util/richTextHelpers';
import { convertMarkdownToReact } from '../../util/markdownHelpers';

function TermsAndConditionsCustomPage(props) {
  const { onUpdateProfile, params, scrollingDisabled } = props;

  const dispatch = useDispatch();
  const terms = useSelector(getTermsSelector);

  useEffect(() => {
    dispatch(fetchTerms({}));
  }, [dispatch]);


  // Get the raw content data
  const rawContent = terms?.Content;
  
  // Extract plain text for meta content
  let contentText = '';
  let content = null;

  if (Array.isArray(rawContent)) {
    // It's Strapi rich text format
    contentText = extractPlainTextFromStrapiRichText(rawContent);
    content = convertStrapiRichTextToReact(rawContent);
  } else if (typeof rawContent === 'string') {
    // It's markdown or plain text
    contentText = rawContent;
    content = convertMarkdownToReact(rawContent);
  }

  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();

  const redirectToSignupPage = () => {
    history.push(createResourceLocatorString('SignupPage', routeConfiguration, {}));
  };

  return (
    <Page title={'Terms and Conditions'} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn
        topbar={
          <TopbarContainer mobileRootClassName={css.mobileTopbar} desktopClassName={css.desktopTopbar} />
        }
        footer={<FooterContainer />}
      >
        <div className={css.privacyContainer}>
          <h4 className={css.privacySubheading}>iParley</h4>
          <h1 className={css.privacyHeading}>{(terms?.Heading || terms?.title || terms?.attributes?.title) ?? 'Terms & Conditions'}</h1>

          <div className={css.privacyBlock}>
            <div className={css.privacyContent}>
              {/* <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}> */}
              {content}
              {/* </ReactMarkdown> */}
            </div>
          </div>

        </div>
      </LayoutSingleColumn>
    </Page>
  );
}

TermsAndConditionsCustomPage.propTypes = {
  onUpdateProfile: func.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const mapDispatchToProps = dispatch => ({
  onUpdateProfile: data => dispatch(updateProfile(data)),
});

export default TermsAndConditionsCustomPage = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(TermsAndConditionsCustomPage);
